import {
  Badge,
  DropdownButton,
  FlexBox,
  Table,
  Text,
} from '@dixa/lib-shared-habla';

import { CustomForm } from '../../../../../customForms.types';

import { FormRowDropdownContent } from './formRowDropdownContent';
import { FormUsageRows } from './formUsageRows';
import styles from './styles.module.scss';

type Props = {
  form: CustomForm;
  onEdit: () => void;
  onRename: () => void;
  onDuplicate: () => void;
  onDelete: () => void;
};

export function FormTableRow({ form, ...rest }: Props): JSX.Element {
  return (
    <Table.Tr
      rowId={form.id}
      expandableContent={<FormUsageRows usage={form.usage} />}
    >
      <Table.Td>
        <Text.Paragraph variant="2">
          {form.title}
          {form.hasAttributes === false && (
            <Badge variant="warning" size="small" className={styles.badge}>
              &nbsp;No fields added
            </Badge>
          )}
        </Text.Paragraph>
      </Table.Td>

      <Table.Td>
        {form.usage.length > 0 && (
          <Text.Paragraph variant="2">
            {makeFlowUsageCount(form.usage.length)}
          </Text.Paragraph>
        )}
      </Table.Td>

      <Table.Td>
        <FlexBox alignItems="center" justifyContent="end">
          <DropdownButton
            noArrow
            fixed
            icon="dots-h"
            dropdown={<FormRowDropdownContent {...rest} />}
          />
        </FlexBox>
      </Table.Td>
    </Table.Tr>
  );
}

function makeFlowUsageCount(count: number): string {
  return `${count} flow${count === 1 ? '' : 's'}`;
}
